<h1 mat-dialog-title>{{'invoiceProcessing.codingProposal' | translate}}</h1>
<mat-dialog-content>
    <p>
        {{data.message}}
    </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button color="primary" mat-dialog-close cdkFocusInitial>
        {{'invoiceProcessing.codingProposalConfirmDialog.cancel' | translate}}
    </button>
    <button mat-button color="primary" [mat-dialog-close]="true">
        {{'invoiceProcessing.codingProposalConfirmDialog.confirm' | translate}}
    </button>
</mat-dialog-actions>



